import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting,
  APV, BokkzSbLogic,
  Effecten,
  GiftTaxEntity,
  NotarieleAkte,
  OmschrijvingEnBedrag,
  OndernemingSB,
  OnroerendeZaakSB,
  PU,
  RoerendeZaak,
  RoerendeZaakSoortRoerendeZaak,
  Schenking,
  SchenkingOpPapier,
  SchenkingRelatieBegiftigdeMetSchenker,
  Vrijstellingen,
  Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {BokkzAlgDataService, BokkzSbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-roerende-zaken',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule
  ],
  templateUrl: './roerende-zaken.component.html',
  styleUrl: './roerende-zaken.component.css'
})
export class RoerendeZakenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private giftTaxEntitySubscription: Subscription | undefined;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public schenkingFg = {} as FormGroup;
  public rzFg = {} as FormGroup;
  public focusedElementId: string | null = null;

  public optionsRoerendeZaken: SelectFormControlItem<string>[] = [
    {value: "INBOEDEL", label: "Inboedel"},
    {value: "VERVOERSMIDDELEN", label: "Vervoersmiddelen"},
    {value: "KUNST_EN_ANTIEK", label: "Kunst en antiek"},
    {value: "OVERIG", label: "Overige roerende zaken"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    public sbService: BokkzSbLogic,
    private fb: FormBuilder) {
    this.schenkingFg = this.fb.group<Schenking>({
      datumSchenking: null as unknown as Date,
      relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
      herroepelijkeSchenking: null as unknown as boolean,
      schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
      uitbreidingBegripSchenker: null as unknown as boolean,
      contanten: null as unknown as OmschrijvingEnBedrag,
      effecten: null as unknown as Effecten,
      onroerendeZaken: null as unknown as OnroerendeZaakSB,
      ondernemingen: null as unknown as OndernemingSB,
      apv: null as unknown as APV,
      periodiekeUitkering: null as unknown as PU,
      roerendeZaak: null as unknown as RoerendeZaak,
      schuldigerkenning: null as unknown as SchenkingOpPapier,
      kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
      vruchtgebruik: null as unknown as Vruchtgebruik,
      overige: null as unknown as OmschrijvingEnBedrag,
      vrijstellingen: null as unknown as Vrijstellingen,
      notarieleAkte: null as unknown as NotarieleAkte,
      belastingBetaaldInAnderLand: null as unknown as number,
      landCodeBetaaldInAnderLand: null as unknown as string,
    })
    this.rzFg = this.fb.group<RoerendeZaak>({
      omschrijving: null as unknown as string,
      bedrag: null as unknown as number,
      soortRoerendeZaak: null as unknown as RoerendeZaakSoortRoerendeZaak,
    })
  }

  ngOnInit(): void {
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value) => {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
      if (value.aangifte!.schenking) {
        this.schenkingFg.patchValue(value.aangifte!.schenking[0], {emitEvent: false})
        if (value.aangifte!.schenking[0] && value.aangifte!.schenking[0].roerendeZaak) {
          this.rzFg.patchValue(value.aangifte!.schenking[0].roerendeZaak, {emitEvent: false})
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.rzFg.updateValueAndValidity();
    this.schenkingFg.updateValueAndValidity();
    const schenking = this.schenkingFg.value;
    schenking.roerendeZaak = {
      omschrijving: this.rzFg.value.omschrijving,
      bedrag: this.rzFg.value.bedrag,
      soortRoerendeZaak: this.rzFg.value.soortRoerendeZaak
    }
    this.giftTaxEntity.aangifte = {
      ...this.sbAangifte,
      schenking: [schenking],
    } as AangifteSchenkbelasting;
    this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    setTimeout(()=> {
      this.sbService.getCalculation();
    }, 1500)
  }
}

